import React from 'react';
import AboutHero from '../about/AboutHero';
import PurposeSection from '../about/PurposeSection';
import MetricsRibbon from '../about/MetricsRibbon';
import JourneyTimeline from '../about/JourneyTimeline';
import Differentiators from '../about/Differentiators';
import TopInstructors from '../home/TopInstructors';
import Principles from '../about/Principles';
import StrongerTogether from '../about/StrongerTogether';
import ConversionCTA from '../about/ConversionCTA';

import "../../styles/CardComponents.css";

export default function About() {
  return (
    <main className="client-about-view-root">
      <AboutHero />
      <PurposeSection />
      <MetricsRibbon />
      <JourneyTimeline />
      <Differentiators />
      <TopInstructors />
      <Principles />
      <StrongerTogether />
      <ConversionCTA />
    </main>
  );
}